import Vue from 'vue'
import App from './Blog.vue'
import i18n from '../i18n'
import Buefy from 'buefy'

Vue.use(Buefy);
Vue.config.productionTip = false;

new Vue({
    i18n,
    render (h) { return h(App) }
}).$mount('#app');
